import { createSvgIcon } from "@material-ui/core";
import { ReactComponent as InformationIconSvg } from "./information.svg";

export const InformationIcon = createSvgIcon(<InformationIconSvg />, "InformationIcon");
